import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import ToggleSwitch from '../ToggleSwitch' //


const ProfileProperty = ({ title, description, status, onToggle }) => {


    // const { popupTheme } = useSelector(store => store.themeConfigReducers)

    const { profileManagementThemes = {} } = useSelector(store => store.profileManagement)

    const [theme, setTheme] = useState(null)

    // --Setting Profile List Theme---
    useEffect(() => {
        if (profileManagementThemes && profileManagementThemes.themeProfileDetails) setTheme(profileManagementThemes.themeProfileDetails)
    }, [profileManagementThemes])

    

    return (
        <ProfilePropertyStyle>
            <div className="profile-property-wrapper">
                <div className="profile-property-wrapper__text">
                    <div className="profile-property-wrapper__text__title">
                        {title}
                    </div>
                    <div className="profile-property-wrapper__text__description">
                        {description}
                    </div>
                </div>
                <div className="profile-property-wrapper__toggle">

                    <ToggleSwitch theme={theme} checked={status} onChange={onToggle} />
                </div>
            </div>
        </ProfilePropertyStyle>
    )
}

const ProfilePropertyStyle = styled.div`
    .profile-property-wrapper{
        width: 100%;
        border-top: 1px solid grey;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 26px 0px 25px 0px;
        margin-top: 30px; // TO BE REMOVED

        .profile-property-wrapper__text{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-items: flex-start;
            max-width: 80%;
                                
            .profile-property-wrapper__text__title{
                font-size: 16px;
                font-weight: 600;
                color: #ffffff;
            }//profile-property-wrapper__text__title
            .profile-property-wrapper__text__description{
                font-size: 16px;
                color: #a6a6a6;
                
                margin-top: 5px;
            }//profile-property-wrapper__text__description
        }//profile-property-wrapper__text
        .profile-property-wrapper__toggle{
            margin-left: auto;
        }//profile-property-wrapper__toggle
    }//profile-property-wrapper
`

export default ProfileProperty